<template>
  <div class="content">
    <controlbar
      :dispItems="assigns"
      @input-event="setAssigns"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="name_label assign_btn">
              {{ nameLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispAssign in assigns"
            :key="dispAssign.userId"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispAssign.checked"
                @click="checkedAction(dispAssign)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispAssign)">
              <label :class="['assign_btn', changeColorClass(dispAssign.type)]">
                {{ dispAssign.name }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setAssigns(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      nameLabel: '役割',
      showFalseModal: false,
      showCompleteModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    assigns() {
      return this.$store.state.assigns.assigns
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.assigns.total) {
        return this.$store.state.assigns.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.assigns.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.assigns.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('assigns/clearSelectedAssignList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setAssigns(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    changeColorClass(typeId) {
      const colorMap = {
        1: 'btn_red',
        2: 'btn_yellow',
        3: 'btn_green',
        4: 'btn_blue',
        5: 'btn_skyblue',
        6: 'btn_pink',
        7: 'btn_purple',
        8: 'btn_brown'
      }
      return colorMap[typeId] || ''
    },
    selectedTypeName(typeId) {
      let name = ''
      let selectedType = this.$store.state.assigns.typeList.find(
        type => type.id === typeId
      )
      if (selectedType) {
        name = selectedType.name
      }
      return name
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.assigns.length; i++) {
        this.assigns[i].checked = this.checked
      }
      this.$store.dispatch('assigns/updateSelectedAssignList', this.assigns)
    },
    checkedAction(assign) {
      assign.checked = !assign.checked
      this.$store.dispatch('assigns/updateSelectedAssignList', [assign])
    },
    close(e) {
      this.showFalseModal = false
      this.showCompleteModal = false
    },
    async reload() {
      this.$store.dispatch('assigns/clearSelectedAssignList')
      await this.setAssigns(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setAssigns(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('assigns/setAssigns', {
          pageNo: pageNo
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = 'MSGCRC0222'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0222.name +
            this.errorMsg.MSGCRC0222.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('assigns/setDetailAssign', payload)
        if (location.pathname !== '/assigns/detail') {
          this.$router.push('../assigns/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = 'MSGCRC0223'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0223.name +
            this.errorMsg.MSGCRC0223.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
td {
  width: 25%;
}
.assign_btn {
  padding: 5px;
  border-radius: 7px;
}
.btn_red {
  border: 2px solid #df3000;
  background-color: #e95504;
  color: #ffffff;
}

.btn_yellow {
  border: 2px solid #928c00;
  background-color: #fff100;
  color: #000000;
}

.btn_green {
  border: 2px solid #007d5d;
  background-color: #00a283;
  color: #ffffff;
}

.btn_blue {
  border: 2px solid #20387f;
  background-color: #0079c2;
  color: #ffffff;
}

.btn_skyblue {
  border: 2px solid #30a6eb;
  background-color: #54c2f0;
  color: #0041ff;
}

.btn_pink {
  border: 2px solid #eb8ab2;
  background-color: #f4b5d0;
  color: #5d0c75;
}

.btn_purple {
  border: 2px solid #5d0c75;
  background-color: #5d0c75;
  color: #ffffff;
}

.btn_brown {
  border: 2px solid #652810;
  background-color: #8a4824;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/assigns/assignsList.vue